module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-500.17976b1c.woff";